import { Platform } from 'react-native';

export const CONNECTIONS_MANAGE_ENABLED = Platform.OS !== 'web';
